import { alpha, createTheme } from '@mui/material/styles';

export const assetFlowTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#143f6b',
      dark: '#102f51',
      light: '#2f618f',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#0f766e',
      dark: '#115e59',
      light: '#14b8a6',
    },
    success: {
      main: '#15803d',
    },
    warning: {
      main: '#b45309',
    },
    error: {
      main: '#b42318',
    },
    info: {
      main: '#0e7490',
    },
    background: {
      default: '#eef3f9',
      paper: '#ffffff',
    },
    text: {
      primary: '#0f172a',
      secondary: '#475569',
    },
    divider: '#d6deea',
  },
  typography: {
    fontFamily: 'Inter, Segoe UI, Arial, sans-serif',
    h1: {
      fontWeight: 700,
      letterSpacing: '-0.04em',
    },
    h2: {
      fontWeight: 700,
      letterSpacing: '-0.03em',
    },
    h3: {
      fontWeight: 700,
    },
    h4: {
      fontWeight: 700,
    },
    h5: {
      fontWeight: 700,
    },
    h6: {
      fontWeight: 700,
    },
    button: {
      textTransform: 'none',
      fontWeight: 600,
    },
  },
  shape: {
    borderRadius: 16,
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: (theme) => ({
        html: {
          width: '100%',
          height: '100%',
        },
        body: {
          width: '100%',
          height: '100%',
          margin: 0,
          backgroundColor: theme.palette.background.default,
          backgroundImage:
            'radial-gradient(circle at top left, rgba(20, 63, 107, 0.18), transparent 28%), radial-gradient(circle at top right, rgba(15, 118, 110, 0.12), transparent 24%), linear-gradient(180deg, #f4f7fb 0%, #eef3f9 100%)',
          backgroundAttachment: 'fixed',
        },
        '#root': {
          minHeight: '100%',
        },
        '*': {
          boxSizing: 'border-box',
        },
        '::selection': {
          backgroundColor: alpha(theme.palette.primary.main, 0.18),
        },
      }),
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundImage: 'linear-gradient(90deg, #102f51 0%, #143f6b 60%, #0f766e 100%)',
          boxShadow: '0 16px 40px rgba(15, 23, 42, 0.16)',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          border: '1px solid rgba(148, 163, 184, 0.14)',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          boxShadow: '0 16px 36px rgba(15, 23, 42, 0.08)',
          backdropFilter: 'blur(10px)',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: 'none',
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          fontWeight: 600,
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        head: {
          fontWeight: 700,
          backgroundColor: 'rgba(241, 245, 249, 0.9)',
        },
      },
    },
  },
});